__turbopack_context__.v({
  "fade-in": "DemoVehicleBadge-module-scss-module__vPQ9fW__fade-in",
  "infoButton": "DemoVehicleBadge-module-scss-module__vPQ9fW__infoButton",
  "no-transform": "DemoVehicleBadge-module-scss-module__vPQ9fW__no-transform",
  "rotate": "DemoVehicleBadge-module-scss-module__vPQ9fW__rotate",
});
